import CoreUtils from './CoreUtils';

const numberDisplayOptions = {
  maximumFractionDigits: 2
};

export default class NumberUtils {
  static padZerosIfNeeded(value, digitCount) {
    var stringValue = String(value);

    while (stringValue.length < (digitCount)) { stringValue = "0" + stringValue; }
    return stringValue;
  }

  static formatNumber(value, locale) {
    return CoreUtils.isDefinedAndNotNull(value) && !isNaN(value)
      ? value.toLocaleString(locale, numberDisplayOptions)
      : '';
  }
}